<template>
    <div >
      <el-dialog v-bind="$attrs" title="更多条件" :visible.sync="showDialog" :close-on-click-modal="false" width="790px" @close="close" >
        <div class="wheremore-box">
          <template v-for="(item, i) in components">
            <template v-if="item.controlGroup == 'SearchMore'">
              <jr-inputwhere v-if="item.controlType == 'Input'" v-model="componentsProps[item.controlId]" :components="item" :badge="badge" v-on="$listeners"></jr-inputwhere>
              <jr-datetimewhere v-if="item.controlType == 'Date' || item.controlType == 'Datetime'" v-model="componentsProps[item.controlId]" :components="item" :badge="badge" v-on="$listeners"></jr-datetimewhere>
              <!-- Station -->
              <jr-selectwhere v-if="item.controlType == 'Select' && item.controlDatasource == 'Station'" v-model="componentsProps[item.controlId]" :selectData="$store.getters.stationCut" :selectDataParam="{'label':'stationName', 'value':'stationId'}" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              <!-- Department -->
              <jr-selectwhere v-if="item.controlType == 'Select' && item.controlDatasource == 'Department'" v-model="componentsProps[item.controlId]" :selectData="$store.getters.department" :selectDataParam="{'label':'departmentName', 'value':'departmentId'}" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              <!-- sex -->
              <jr-selectwhere v-if="item.controlType == 'Select' && item.controlDatasource == 'sex'" v-model="componentsProps[item.controlId]" :selectData="sex" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              <!-- yesOrno -->
              <jr-selectwhere v-if="item.controlType == 'Select' && item.controlDatasource == 'yesOrno'" v-model="componentsProps[item.controlId]" :selectData="yesOrno" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              <!-- existsType -->
              <jr-selectwhere v-if="item.controlType == 'Select' && item.controlDatasource == 'existsType'" v-model="componentsProps[item.controlId]" :selectData="existsType" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              <!-- sys_type -->
              <jr-selectwhere v-if="item.controlType == 'SelectType'" v-model="componentsProps[item.controlId]" :selectData="$store.getters.sysTypeAll[item.controlDatasource].childSysType" :selectDataParam="{'label':'typeName', 'value':'typeId'}" :components="item" :badge="badge" v-on="$listeners"></jr-selectwhere>
              
            </template>
          </template>
    
          <br>
        </div>        
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetClick">重 置</el-button>
          <el-button type="primary" @click="close">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
import JRGLOBAL from '@/api/jrglobal'
export default {
  name: 'JrWheremore',
  computed: {
    componentsProps: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {
      showDialog: false,
      // 性别
      sex: JRGLOBAL.sex,
      // 是否
      yesOrno: JRGLOBAL.yesOrno,
      // 是否有效
      existsType: JRGLOBAL.existsType,
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {}
    
  },
  methods: {
    // 重置按钮
    resetClick() {
      for(var key in this.components){
        if(this.components[key].controlGroup == 'SearchMore'){
          this.$set(this.componentsProps, this.components[key].controlId, this.components[key])
        }
      }
      this.componentsProps = JSON.parse(JSON.stringify(this.componentsProps))
    },
    // 显示事件
    showType(){
      this.showDialog = true
    },
    // 窗口关闭事件
    close(){
      this.showDialog = false
    }
  }
}

</script>
<style scoped lang="scss">
  .wheremore-box{
    width: 680px;
    height: 400px;
    overflow-y: scroll;
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrWheremore.vue